/* eslint-disable prefer-destructuring */
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { I18n } from '@corporate/ng-tebis-base-components';
import { MDIRouteActivation } from '../../../05_layout/main-layout/feature-instance/feature-instance.component';
import { TabService } from '../../../05_layout/flat-layout/flat-tabs/tab.service';
import { NavbarComponent } from '../../navbars/navbar/navbar.component';
import { NavbarButtonComponent } from '../../navbars/navbar-button/navbar-button.component';
import { OrderNavbarService } from './order-navbar.service';
import { ProcessNavigationComponent } from '../../../02_ui/process-navigation/process-navigation.component';

@Component({
  selector: 'tps-manufacturing-order-navbar',
  imports: [
    MatIconModule,
    NavbarComponent,
    NavbarButtonComponent,
    ProcessNavigationComponent,
  ],
  templateUrl: './manufacturing-order-navbar.component.html',
  styleUrl: './manufacturing-order-navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManufacturingOrderNavbarComponent {

  i18n = inject(I18n);

  tabService = inject(TabService);
  routeActivation = inject(MDIRouteActivation);
  route = input<string|undefined>();

  state = inject(OrderNavbarService);

  orderID = input.required<string>();

  selected = computed(() => this.tabService.getCurrentPath() || this.route() || '');

  parentTab = computed(() => {
    let parent = this.tabService.getCurrentTab();
    const parentPath = `order/${this.orderID()}`;
    if (parent.parent && parent.path !== parentPath) {
      parent = parent.parent;
    }
    return parent;
  });

  constructor() {
    this.i18n.addNamespace('manufacturing-order');
  }
}
